/**
 * @vuelto-surface
 * mobile: skip
 * desktop: ok
 * strategy: web-only
 */
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { ticketColors } from '../../shared/theme/ticketColors';
import { useWebBuildVersionCheck } from './useWebBuildVersionCheck';

/**
 * Overlay bloqueante cuando el servidor deployó un build más nuevo que el que
 * corre esta pestaña. Aparece al retomar la pestaña (o apenas llega el evento
 * Realtime) — nunca recarga solo para no perder un cobro a medias.
 */
export function WebUpdateOverlay() {
  const stale = useWebBuildVersionCheck();
  if (Platform.OS !== 'web' || !stale) return null;

  return (
    <View style={styles.overlay} accessibilityRole="alert">
      <View style={styles.card}>
        <Text style={styles.title}>Hay una versión nueva de Vuelto</Text>
        <Text style={styles.message}>
          Actualizamos la app mientras no estabas. Recargá para seguir con la última versión.
        </Text>
        <TouchableOpacity
          style={styles.button}
          onPress={() => {
            if (typeof window !== 'undefined') window.location.reload();
          }}
          accessibilityRole="button"
          accessibilityLabel="Recargar"
        >
          <Text style={styles.buttonText}>Recargar</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  card: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: ticketColors.paper,
    borderRadius: 14,
    padding: 24,
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: ticketColors.ink,
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 15,
    color: ticketColors.ink2,
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 21,
  },
  button: {
    backgroundColor: ticketColors.gold,
    paddingVertical: 14,
    paddingHorizontal: 32,
    borderRadius: 10,
    width: '100%',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});
